import { trackEvent } from "./mixpanel";
import { trackChatwootEvent } from "./chatwoot";

const ENV_PREFIX = process.env.REACT_APP_ENV_PREFIX || "staging";

const currentUser = () => {
  try {
    return JSON.parse(localStorage.getItem(`${ENV_PREFIX}_userData`)) || null;
  } catch (e) {
    return null;
  }
};

export const track = (eventName, properties = {}) => {
  const user = currentUser();
  const payload = {
    user_email: user?.email || "Anonymous",
    logged_in: !!user?.id,
    page: window.location.pathname,
    ...properties,
  };
  trackEvent(eventName, payload);
  trackChatwootEvent(eventName, payload);
};
